module.exports = __webpack_public_path__ + "media/bootstrap-icons/key-4a2d3eda.svg";